import style from './styles/SecuredPaymentInfo.scss';
import RouteHelper from '../../../helpers/RouteHelper';
import { Link } from 'react-router-dom';
import Logo from '../../logo';
import {FOOTSHOP_LOGO_COLORS} from '../../logo/constants';

const SecuredPaymentInfo = () => (
	<div className={style['secured-payment']}>
		<div className={style.logo}>
			<Link to={RouteHelper.getUrl('/')}>
				<Logo color={FOOTSHOP_LOGO_COLORS.WHITE}/>
			</Link>
		</div>
		<div className={style['separator-desktop']} />
		<div className={style.icon} />
		<div className={style.text}>Secure<br />payment</div>
		<div className={style.separator} />
		<div className={style['your-order']}>Your Order</div>
	</div>
);

export default SecuredPaymentInfo;


// WEBPACK FOOTER //
// ./components/blocks/raffleForm/SecuredPaymentInfo.js